import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import config from "./config";

export const base_url = config.api.baseUrl;
export const URL = {
  // STS_TOKEN: `${base_url}/companionapp/token`,
  STS_TOKEN: `${base_url}/images/token`,
  GET_ALL_CUSTOMERS: `${base_url}/users/allorganizations`,
  VEHICLE_DETAILS: `${base_url}/vehicles/:serialNo`,
  COMPANION_VEHICLE_DETAILS: `${base_url}/companionapp/cloud-simulator/vehicles/:vehicleKey`,
  GET_EXECUTIONS: `${base_url}/v3/executions/:serialNo`,
  GET_JOB_DOCUMENT: `${base_url}/v3/jobDocument/:deploymentId`,
  DESCRIBE_JOB_EXECUTION: `${base_url}/v3/describe/executions/:serialNo/deployment/:deploymentId/:executionId`,
  UPDATE_EXECUTION: `${base_url}/v3/updateJobExecution`,
  UPDATE_AUDIT_SIGNAL: `${base_url}/v3/updateExecutionSignal`,
  GET_SHADOW_STATE: `${base_url}/vehicles/:serialNo/shadow`,
};

export const getSTSToken = async () => {
  return await axios.get(URL.STS_TOKEN);
};

export const getAllCustomers = async () => {
  return await axios.get(URL.GET_ALL_CUSTOMERS);
};

export const getCompanionVehicleDetails = async ({ queryKey }) => {
  const [_, vehicleKey] = queryKey;
  const url = URL.COMPANION_VEHICLE_DETAILS.replace(":vehicleKey", vehicleKey);
  return await axios.get(url);
};

export const getVehicleDetails = async ({ queryKey }) => {
  const [_, serialNo] = queryKey;
  const url = URL.VEHICLE_DETAILS.replace(":serialNo", serialNo);
  return await axios.get(url);
};

export const getIDToken = async () => {
  const session = await fetchAuthSession();
  return session.tokens.idToken || null;
};

export const isIdTokenExpired = async () => {
  const session = await fetchAuthSession();

  var idTokenExpire = session.tokens.idToken.payload.exp;
  console.log("ID Token Expire Time", idTokenExpire);
  let newDateTime = new Date().getTime() / 1000;
  const currentTimeMin = Math.trunc(newDateTime);
  return currentTimeMin > idTokenExpire;
};

export const refreshIdToken = async () => {
  return await fetchAuthSession({ forceRefresh: true });
};

export const getDeploymentExecution = async ({ queryKey }) => {
  const [_, serialNo] = queryKey;
  const url = URL.GET_EXECUTIONS.replace(":serialNo", serialNo);
  return await axios.get(url);
};

export const getShadowState = async ({ queryKey }) => {
  const [_, serialNo] = queryKey;
  const url = URL.GET_SHADOW_STATE.replace(":serialNo", serialNo);
  return await axios.get(url);
};

export const getJobDocument = async ({ queryKey }) => {
  const [_, deploymentId] = queryKey;
  const url = URL.GET_JOB_DOCUMENT.replace(":deploymentId", deploymentId);
  return await axios.get(url);
};

export const updateJobExecution = async (payload) => {
  return await axios.post(URL.UPDATE_EXECUTION, payload);
};

export const updateAuditSignal = async (payload) => {
  return await axios.post(URL.UPDATE_AUDIT_SIGNAL, payload);
};

export const describeJobExecution = async ({ queryKey }) => {
  const [_, serialNo, deploymentId, executionId] = queryKey;
  const url = URL.DESCRIBE_JOB_EXECUTION.replace(":deploymentId", deploymentId)
    .replace(":serialNo", serialNo)
    .replace(":executionId", executionId);
  return await axios.get(url);
};

export const getFaultData = async ({ queryKey }) => {
  const [_, vehicleKey, duration, page, take] = queryKey;
  // const base_url="http://localhost:3500"
  const url = `${base_url}/companionapp/fault/data/${vehicleKey}`;
  const params = {
    page: Number(page) || 1,
    take: Number(take) || 10,
  };
  if (duration) params.duration = duration;
  return await axios.get(url, { params });
};